export default "__VITE_ASSET__BHBPj1e$__"